import { Capacitor } from "@capacitor/core";

export const isNative = Capacitor.isNativePlatform();
export const nativePlatform = isNative ? Capacitor.getPlatform() : null;
export const WEBSITE_URL = "https://futuregen-innovations.com";

const TOKENS_KEY = "fg_native_tokens";
const GUEST_KEY = "fg_native_guest";

export function getTokens() {
  try { return JSON.parse(localStorage.getItem(TOKENS_KEY)) || null; } catch { return null; }
}
export function setTokens(tokens) {
  if (tokens) localStorage.setItem(TOKENS_KEY, JSON.stringify(tokens));
  else localStorage.removeItem(TOKENS_KEY);
}
export function getGuestId() { return localStorage.getItem(GUEST_KEY) || ""; }
export function setGuestId(id) { if (id) localStorage.setItem(GUEST_KEY, id); }

export function nativeHeaders() {
  if (!isNative) return {};
  const h = { "X-Client-Platform": nativePlatform };
  const t = getTokens();
  if (t?.access_token) h.Authorization = `Bearer ${t.access_token}`;
  const g = getGuestId();
  if (g) h["X-Guest-Id"] = g;
  return h;
}

export async function openExternal(url) {
  if (isNative) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
  } else {
    window.location.href = url;
  }
}
